import React from 'react'

const OrderedProductList = () => {
  return (
    <div>OrderedProductList</div>
  )
}

export default OrderedProductList